import { createFileRoute, useSearch } from '@tanstack/react-router';
import StatusError from 'src/components/access/StatusError';
import GeneralStatusError from 'src/components/access/StatusError/GeneralStatusError';

export const Route = createFileRoute('/access_/error')({
	component: ErrorPage,
});

function ErrorPage() {
	const search = useSearch({ strict: false }) as {
		'invalid-invite'?: string;
		statusCode?: string;
		occurredAt?: string;
		method?: string;
		uuid?: string;
	};

	const isInvalidInvite = 'invalid-invite' in search;

	if (isInvalidInvite) {
		return (
			<StatusError>
				<div className="w-full flex flex-col items-center justify-center flex-grow mt-16">
					<div className="w-[300px] h-full flex flex-col justify-center items-center">
						<StatusError.Illustration src="/public/access_denied.svg" />
					</div>
					<StatusError.Label>Invalid Invite</StatusError.Label>
					<StatusError.Section.Title>The invite link you used is invalid or has expired</StatusError.Section.Title>
				</div>
			</StatusError>
		);
	}

	return (
		<GeneralStatusError
			illustrationSrc="/public/warning.svg"
			label={`${search.statusCode || ''} - Something went wrong`}
			occurredAt={search.occurredAt}
			method={search.method}
			uuid={search.uuid}
			action={{
				label: 'Go Back',
				onClick: () => {
					window.location.href = '/access';
				},
			}}
		/>
	);
}
